<template>
  <morphology-solution-info/>
</template>

<script>

import MorphologySolutionInfo from "@/components/MorphologySolutionInfo";

export default {
    name: 'MorphologyMainPanel',

    components: {
        MorphologySolutionInfo
    },

    data: () => ({
    }),

    methods: {
    }
  }
</script>
